import React, { Fragment, useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList } from "@fortawesome/free-solid-svg-icons";
import Spinner from 'react-bootstrap/Spinner';
import DetailedSurcharges from '../../../../Reports/components/DetailedSurcharges/DetailedSurcharges';

const IconButtonDetailSurcharge = ({ data, id_factura_t }) => {

    const [dataDetailSurcharge, setDataDetailShurcharge] = useState([]);
    const [loadingDetailDataShurcharge, setLoadingDataShurcharge] = useState(false);
    const [openModalDetailShurcharge, setOpenModalDetailShurcharge] = useState(false);

    const getInvoiceDataDetail = async () => {
        setLoadingDataShurcharge(true);
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}reportes/detallado-recargos`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_factura_t: id_factura_t
            })
        }).then((response) => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then((dataDetail) => {
            setLoadingDataShurcharge(false);
            setDataDetailShurcharge(dataDetail);
            setOpenModalDetailShurcharge(true);
        }).catch(err => {
            setLoadingDataShurcharge(false);
            setDataDetailShurcharge([]);
            setOpenModalDetailShurcharge(false);
        });
    }

    return (<Fragment>

        {
            loadingDetailDataShurcharge == false ? <Tooltip title="Detalles de Recargos">
                <IconButton
                    aria-label="print"
                    disabled={!(data?.data?.original.factura_salud ?? data.factura_salud)}
                    style={{ padding: 2 }}
                    onClick={() => {
                        getInvoiceDataDetail();
                    }}
                >
                    <FontAwesomeIcon icon={faClipboardList} />
                </IconButton>
            </Tooltip> : <Spinner style={{ width: '24px', height: '24px' }} animation="border" variant="success" />
        }

        {
            openModalDetailShurcharge == true ?
                <DetailedSurcharges
                    opened={openModalDetailShurcharge}
                    closeModal={() => setOpenModalDetailShurcharge(false)}
                    data={dataDetailSurcharge}
                    numFacTer={data?.data?.original.num_fac_ter ?? data.num_fac_ter}
                /> : null
        }

    </Fragment>)
}

export default IconButtonDetailSurcharge;